import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsIconRegistry,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import {
    mdiCheck,
    mdiChevronDown,
    mdiChevronRight,
    mdiChevronUp,
    mdiClose,
    mdiDotsVertical,
    mdiLaunch,
} from '@mdi/js';

import { CmpsMetricPerformanceModule } from '../metric-performance/metric-performance.module';

import { CmpsInsightCoachingPerformanceComponent } from './insight-coaching-performance.component';

@NgModule({
    declarations: [CmpsInsightCoachingPerformanceComponent],
    imports: [
        CmpsButtonModule,
        CmpsIconModule,
        CmpsTooltipModule,
        CommonModule,
        CmpsMetricPerformanceModule,
    ],
    exports: [CmpsInsightCoachingPerformanceComponent],
    entryComponents: [CmpsInsightCoachingPerformanceComponent],
})
export class CmpsInsightCoachingPerformanceModule {
    constructor(
        private readonly _domSanitizer: DomSanitizer,
        private readonly _iconRegistry: CmpsIconRegistry,
    ) {
        [
            ['dots', mdiDotsVertical],
            ['chevron-right', mdiChevronRight],
            ['chevron-up', mdiChevronUp],
            ['chevron-down', mdiChevronDown],
            ['close', mdiClose],
            ['check', mdiCheck],
            ['launch', mdiLaunch],
        ].forEach(([name, icon]) => {
            _iconRegistry.addSvgIconFromHtml(
                name,
                _domSanitizer.bypassSecurityTrustHtml(
                    `<svg id="${name}"><path d="${icon}"></path></svg>`,
                ),
                '__internal',
            );
        });
    }
}
